import { render } from "./ItemSelectorStep.vue?vue&type=template&id=518970b0&scoped=true"
import script from "./ItemSelectorStep.vue?vue&type=script&lang=ts"
export * from "./ItemSelectorStep.vue?vue&type=script&lang=ts"

import "./ItemSelectorStep.vue?vue&type=style&index=0&id=518970b0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-518970b0"

export default script